import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { getId } from '../Field/Field';
import { fieldMaxWidth, StyledField, StyledFieldLabel } from '../Field/Field.styled';
import { Select } from './Select';
export function NotificationsField(props) {
  var id = getId(props);
  var maxWidth = props.maxWidth || fieldMaxWidth;
  return /*#__PURE__*/React.createElement(StyledField, {
    disabled: props.disabled,
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React.createElement(StyledFieldLabel, {
    htmlFor: props.htmlFor
  }, props.label), /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    id: id
  })));
}